'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ScrapForm = require('./ScrapForm.scss');

var _ScrapForm2 = _interopRequireDefault(_ScrapForm);

var _reduxForm = require('redux-form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrapForm = (_dec = (0, _reduxForm.reduxForm)({
  form: 'survey',
  fields: ['url']
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ScrapForm, _Component);

  function ScrapForm(props) {
    (0, _classCallCheck3.default)(this, ScrapForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ScrapForm).call(this, props));

    _this.state = {
      isLoading: props.isLoading
    };
    return _this;
  }

  (0, _createClass3.default)(ScrapForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.isLoading !== this.state.isLoading) {
        this.setState({ isLoading: newProps.isLoading });
        if (newProps.isLoading === false) {
          this.props.resetForm();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var url = _props.fields.url;
      var handleSubmit = _props.handleSubmit;
      var handleManual = _props.handleManual;
      var resetForm = _props.resetForm;
      var isError = _props.isError;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          { className: _ScrapForm2.default.title },
          'items in this outfit'
        ),
        _react2.default.createElement(
          'form',
          { onSubmit: handleSubmit },
          _react2.default.createElement(
            'div',
            { className: _ScrapForm2.default.form },
            _react2.default.createElement('input', (0, _extends3.default)({ type: 'url', id: 'url', placeholder: 'Paste the link of an item' }, url)),
            !this.state.isLoading && _react2.default.createElement(
              'button',
              { onClick: handleSubmit },
              '+'
            ),
            this.state.isLoading && _react2.default.createElement(
              'button',
              null,
              _react2.default.createElement('div', { className: _ScrapForm2.default.loader })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _ScrapForm2.default.actions },
          _react2.default.createElement(
            'button',
            { className: _ScrapForm2.default.link, onClick: function onClick() {
                return handleManual();
              } },
            '+ Add an item manually'
          ),
          isError && _react2.default.createElement(
            'p',
            { className: _ScrapForm2.default.error },
            'This link is not working 😐'
          )
        )
      );
    }
  }]);
  return ScrapForm;
}(_react.Component)) || _class);


ScrapForm.defaultProps = {
  isLoading: false
};

exports.default = ScrapForm;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ScrapForm/ScrapForm.js
 ** module id = 1105
 ** module chunks = 0
 **/